module.exports = "pegasus/assets/blocks/image-4-theme3.png";